import React from 'react'
import styled from 'styled-components'
import { ScoreSettingProps } from '../types'
import { ScoreInputNumber } from './ScoreInputNumber'
import { CircledNumber } from 'packages/components/CircledNumber'
import { getTheme } from '@/utils/theme'
import { precisionFormat } from 'packages/utils'

/**
 * 分数设置 - 填空题
 * @param props - 参数
 * @param props.block - 题目块
 * @param props.question - 当前题目
 * @param props.serialNumber - 序号
 * @param props.onUpdateScore - 更新分数
 * @param props.isProduct - 当前题目是否是复合题目的子题
 * @returns React.ReactNode
 */
export const FillInBlankScoreSetting: React.FC<
  ScoreSettingProps & { isProduct?: boolean; curIndex: number }
> = (props) => {
  const theme = getTheme()
  const { question, serialNumber, curIndex } = props
  return (
    <Wrapper>
      {question.parentId === 0 ? (
        <>
          <div
            style={{
              color: theme.text._1,
            }}
          >
            {serialNumber}填空
          </div>
          <div style={{ width: '85px', textAlign: 'right' }}>
            {precisionFormat(question.score)}分
          </div>
        </>
      ) : (
        <>
          <LabelWrapper>
            <LIcon />
            <CircledNumber number={curIndex} />
          </LabelWrapper>
          <ScoreInputNumber {...props} />
        </>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const LabelWrapper = styled.div`
  width: 95px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const LIcon = styled.div`
  width: 6px;
  height: 6px;
  margin-right: 4px;
  border-left: 1px solid #afbdc7;
  border-bottom: 1px solid #afbdc7;
`
